// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__wDg4f","load7":"style_load7__NdL01"};